import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function InceptionIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="98" height="99" viewBox="0 0 98 99" fill="none" {...props}>
      <path
        d="M30.9336 0H62.0452V30.8711H31.0234V61.7461H0.00411987V30.7813L30.9336 0Z"
        fill="white"
      />
      <path
        d="M98.003 36.2799L66.9746 36.2896V67.0863L35.9469 67.0584V98.0144H67.0917L98.003 67.2266V36.2799Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default InceptionIcon;
